const MIN_TEMP = -10
const MAX_TEMP = 40
    
export default {
    MIN_TEMP: MIN_TEMP,
    MAX_TEMP: MAX_TEMP,
}